export class Invoice{
  id: number;
  invoiceNo: string;
  invoiceValue: number;
  invoiceDate: string; //date
  incomeMonth: string; //date
  invoiceImageUrl: string;
  originalInvoiceFilename: string;
  memo: string;
}
